const cardImages = [
  require("./cards-images/1_туз_жезлов_рамка.jpg"),
  require("./cards-images/1_туз_кубков_рамка.jpg"),
  require("./cards-images/1_туз_мечей_рамка.jpg"),
  require("./cards-images/1_туз_пентаклей.jpg"),
  require("./cards-images/2_двойка_жезлов_рамка.jpg"),
  require("./cards-images/2_двойка_кубков_рамка.jpg"),
  require("./cards-images/2_двойка_мечей.jpg"),
  require("./cards-images/2_паж_пентаклей.jpg"),
  require("./cards-images/3_рыцарь_пентаклей.jpg"),
  require("./cards-images/3_тройка_жезлов_рамка.jpg"),
  require("./cards-images/3_тройка_кубков_рамка.jpg"),
  require("./cards-images/3_тройка_мечей_рамка.jpg"),
  require("./cards-images/4_король_пентаклей.jpg"),
  require("./cards-images/4_четверка_жезлов_рамка.jpg"),
  require("./cards-images/4_четверка_кубков_рамка.jpg"),
  require("./cards-images/4_четверка_мечей_рамка.jpg"),
  require("./cards-images/5_королева_пентаклей.jpg"),
  require("./cards-images/5_пятерка_жезлов_рамка.jpg"),
  require("./cards-images/5_пятерка_кубков_рамка.jpg"),
  require("./cards-images/5_пятерка_мечей_рамка.jpg"),
  require("./cards-images/6_десятка_пентаклей.jpg"),
  require("./cards-images/6_шестерка_жезлов_рамка.jpg"),
  require("./cards-images/6_шестерка_кубков_рамка.jpg"),
  require("./cards-images/6_шестерка_мечей_рамка.jpg"),
  require("./cards-images/7_девятка_пентаклей.jpg"),
  require("./cards-images/7_семерка_жезлов_рамка.jpg"),
  require("./cards-images/7_семерка_кубков_рамка.jpg"),
  require("./cards-images/7_семерка_мечей_рамка.jpg"),
  require("./cards-images/8_восьмерка жезлов_рамка.jpg"),
  require("./cards-images/8_восьмерка_кубков_рамка.jpg"),
  require("./cards-images/8_восьмерка_мечей_рамка.jpg"),
  require("./cards-images/8_восьмерка_пентаклей.jpg"),
  require("./cards-images/9_девятка_жезлов_рамка.jpg"),
  require("./cards-images/9_девятка_кубков.jpg"),
  require("./cards-images/9_девятка_мечей_рамка.jpg"),
  require("./cards-images/9_семерка_пентаклей.jpg"),
  require("./cards-images/10_десятка_жезлов.jpg"),
  require("./cards-images/10_десятка_кубков_рамка.jpg"),
  require("./cards-images/10_десятка_мечей_рамка.jpg"),
  require("./cards-images/10_шестерка_пентаклей.jpg"),
  require("./cards-images/11_паж_жезлов_рамка.jpg"),
  require("./cards-images/11_паж_кубков_рамка.jpg"),
  require("./cards-images/11_паж_мечей_рамка.jpg"),
  require("./cards-images/11_пятерка_пентаклей.jpg"),
  require("./cards-images/12_рыцарь_жезлов_рамка.jpg"),
  require("./cards-images/12_рыцарь_кубков_рамка.jpg"),
  require("./cards-images/12_рыцарь_мечей_рамка.jpg"),
  require("./cards-images/12_четверка_пентаклей.jpg"),
  require("./cards-images/13_королева жезлов_рамка.jpg"),
  require("./cards-images/13_королева_кубков_рамка.jpg"),
  require("./cards-images/13_королева_мечей_рамка.jpg"),
  require("./cards-images/13_тройка_пентаклей.jpg"),
  require("./cards-images/14_двойка_пентаклей.jpg"),
  require("./cards-images/14_король_жезлов_рамка.jpg"),
  require("./cards-images/14_король_кубков_рамка.jpg"),
  require("./cards-images/14_король_мечей_рамка.jpg"),
  require("./cards-images/башня_рамка.jpg"),
  require("./cards-images/влюбленные_рамка.jpg"),
  require("./cards-images/дьявол_рамка.jpg"),
  require("./cards-images/жрец_рамка.jpg"),
  require("./cards-images/жрица_рамка.jpg"),
  require("./cards-images/звезда_рамка.jpg"),
  require("./cards-images/император_рамка.jpg"),
  require("./cards-images/императрица_рамка.jpg"),
  require("./cards-images/колесница_рамка.jpg"),
  require("./cards-images/колесо_фортуны_рамка.jpg"),
  require("./cards-images/луна_рамка.jpg"),
  require("./cards-images/маг_рамка.jpg"),
  require("./cards-images/мир_рамка.jpg"),
  require("./cards-images/отшельник_рамка.jpg"),
  require("./cards-images/повешенный_рамка.jpg"),
  require("./cards-images/сила_рамка.jpg"),
  require("./cards-images/смерть_рамка.jpg"),
  require("./cards-images/солнце_рамка.jpg"),
  require("./cards-images/справедливость_рамка.jpg"),
  require("./cards-images/суд_рамка.jpg"),
  require("./cards-images/умеренность_рамка.jpg"),
  require("./cards-images/шут_рамка.jpg"),
];

export { cardImages };
